import { Outlet, useMatch } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { SeasonalTheme } from '../theme/seasonal';

export default function Layout() {
  // The overlay builder is a two-column tool (settings beside a live preview),
  // so it gets a wider page than the reading-width pages around it.
  const wide = useMatch('/overlays');
  // The hero washes are wider than the page column on purpose, so they fade out
  // at the window edge rather than at the column's. The page clips them here,
  // at full width: clipping inside the column cut both sides off square, and no
  // clip at all let a 130vw wash scroll a phone sideways. `clip`, not `hidden`,
  // so this is not a scroll container and the sticky header keeps working.
  return (
    <SeasonalTheme>
    <div className="min-h-dvh flex flex-col overflow-x-clip">
      <Header />
      <main className={`flex-1 w-full ${wide ? 'max-w-[1440px]' : 'max-w-6xl'} mx-auto px-6 py-10`}>
        <Outlet />
      </main>
      <Footer />
    </div>
    </SeasonalTheme>
  );
}
